import { render, staticRenderFns } from "./KgjtWebsiteOfflineOrder.vue?vue&type=template&id=d135de32&scoped=true&"
import script from "./KgjtWebsiteOfflineOrder.vue?vue&type=script&lang=js&"
export * from "./KgjtWebsiteOfflineOrder.vue?vue&type=script&lang=js&"
import style0 from "./KgjtWebsiteOfflineOrder.vue?vue&type=style&index=0&id=d135de32&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d135de32",
  null
  
)

export default component.exports